<template>
  <main class="home-shell">
    <header class="home-topbar">
      <h1>Heart-fluttering guests</h1>
      <button class="home-topbar__signal" type="button" aria-label="Personal statement" @click="$router.push('/Personalreport')">
        <span></span><span></span><span></span>
      </button>
    </header>

    <section class="home-hero" :aria-label="$t('frontend.home.banner')">
      <van-swipe
        v-if="bannerSlides.length"
        class="home-hero__swipe"
        :autoplay="3200"
        :duration="500"
        indicator-color="#f1d6e7"
      >
        <van-swipe-item v-for="(banner, index) in bannerSlides" :key="index">
          <img class="home-hero__image" :class="{ 'is-single': bannerSlides.length === 1 }" :src="bannerImage(banner)" :alt="$t('frontend.home.banner')">
        </van-swipe-item>
      </van-swipe>
      <img v-else class="home-hero__image is-single" :src="heroImage" :alt="$t('frontend.home.banner')">
      <div class="home-hero__veil"></div>
      <div class="home-hero__chips">
        <span>Wives</span>
        <span>Students</span>
        <span>Nurses</span>
        <span>Models</span>
        <span>Teachers</span>
      </div>
      <p class="home-hero__note">24/7 service SM equipment Group play Become a member for exclusive perk! Join our club today discover more.</p>
    </section>

    <div class="home-notice" role="note">
      <van-icon name="volume-o" />
      <p>{{ notice || 'Private invitations are opening now. New guests online every minute.' }}</p>
    </div>

    <nav class="home-shortcuts" aria-label="Quick links">
      <button v-for="shortcut in shortcuts" :key="shortcut.path" type="button" :aria-label="shortcut.label" @click="$router.push(shortcut.path)">
        <img :src="shortcut.image" :alt="shortcut.label">
      </button>
    </nav>

    <section class="home-list">
      <h2>I Recommend for You</h2>
      <LoadState v-if="loading" loading compact />
      <LoadState v-else-if="error" :error="error" @retry="load" />
      <template v-else-if="profiles.length">
        <router-link
          v-for="(item, index) in profiles"
          :key="item.id || item.vod_id || index"
          class="guest-card"
          :to="{ path: '/Profile', query: { id: item.id } }"
        >
          <div class="guest-card__body">
            <div class="guest-card__cover">
              <img :src="coverOf(item)" :alt="displayName(item, index)" loading="lazy">
              <i class="guest-card__ribbon">Top</i>
              <strong class="guest-card__name">{{ displayName(item, index) }}</strong>
            </div>
            <div class="guest-card__meta">
              <div class="guest-card__badge-row">
                <span class="badge badge--sand">V VIP3</span>
                <span class="badge badge--sand">V Video</span>
              </div>
              <div class="guest-card__badge-row">
                <span class="badge badge--purple">#Highly recommended</span>
                <span class="badge badge--orange">#Top model figure!</span>
              </div>
              <div class="guest-card__badge-row">
                <span class="badge badge--blue">#college student</span>
                <span class="badge badge--amber">Abalone</span>
              </div>

              <div class="guest-card__rating">
                <span>Price Range:</span>
                <van-rate :value="ratingOf(item)" color="#f7b447" void-icon="star" void-color="#f4d6ac" readonly size="15" />
              </div>
              <p class="guest-card__desc">Height: {{ heightOf(item) }}cm Bust: {{ bustOf(item) }} Age: {{ ageOf(item) }} Service City: {{ cityOf(item) }}</p>
              <span class="guest-card__cta">Date Her</span>
            </div>
          </div>
        </router-link>
      </template>
      <LoadState v-else :empty="$t('frontend.home.no_recommended')" compact />
    </section>
  </main>
</template>

<script>
import LoadState from "../../common/LoadState";
import { assertResponse, imageUrl, rowsOf } from "../../common/reference";

const FALLBACK_COVER = "/img/login/login.png";

export default {
  components: { LoadState },
  data: () => ({
    notice: "", banners: [], featured: [], loading: false, error: "",
    shortcuts: [
      { path: "/Notice", image: "https://ik.imagekit.io/nmil2wj2k/k2a.3750b5b6%20(1).png?updatedAt=1780093708501", label: "Notifications" },
      { path: "/Lottery", image: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(18).png?updatedAt=1780093708511", label: "Dating" },
      { path: "/Video", image: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(17).png?updatedAt=1780093708496", label: "Videos" },
      { path: "/Mine", image: "https://ik.imagekit.io/nmil2wj2k/%E4%B8%8B%E8%BD%BD%20(26).png?updatedAt=1780093708536", label: "My Account" }
    ]
  }),
  computed: {
    bannerSlides() {
      return this.banners.length ? this.banners : [{ image: FALLBACK_COVER }];
    },
    heroImage() {
      return this.banners.length ? this.bannerImage(this.banners[0]) : FALLBACK_COVER;
    },
    profiles() {
      return this.featured.slice(0, 6);
    }
  },
  methods: {
    bannerImage(item) {
      return imageUrl(item.url || item.image || item.img_url) || FALLBACK_COVER;
    },
    coverOf(item) {
      return imageUrl(item.vod_pic || item.cover || item.img || item.img_url) || this.heroImage;
    },
    displayName(item, index) {
      return item.xuanfei_name || item.vod_name || item.name || item.title || `Guest ${index + 1}`;
    },
    ratingOf(item) {
      const raw = Number(item.number || item.star || item.score || 4.6);
      return Math.max(3.5, Math.min(5, Number.isFinite(raw) ? raw : 4.6));
    },
    heightOf(item) {
      const raw = Number(item.hight || item.height || 165);
      return Number.isFinite(raw) ? raw : 165;
    },
    bustOf(item) {
      return item.bust || "A";
    },
    ageOf(item) {
      const raw = Number(item.age || 21);
      return Number.isFinite(raw) ? raw : 21;
    },
    cityOf(item) {
      return item.city || item.area || "Nationwide";
    },
    async load() {
      this.loading = true;
      this.error = "";
      const config = this.$http({ method: "get", url: "sys_config" }).then(response => {
        const result = assertResponse(response);
        this.notice = result.notice || "";
        this.banners = rowsOf(result.banners).filter(item => this.bannerImage(item));
      }).catch(() => {
        this.notice = "";
        this.banners = [];
      });

      try {
        const result = assertResponse(await this.$http({ method: "get", url: "xuanfeilist", data: { id: 0 } }));
        this.featured = rowsOf(result);
      } catch (error) {
        this.error = error.message || this.$t("frontend.video.load_failed");
      } finally {
        await config;
        this.loading = false;
      }
    }
  },
  created() {
    this.load();
  }
};
</script>

<style scoped>
.home-shell {
  min-height: 100vh;
  padding: 0 0.375rem calc(4.35rem + env(safe-area-inset-bottom));
  background: #ffffff;
}

.home-topbar {
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.125rem;
  margin-left: -0.375rem;
  margin-right: -0.375rem;
  padding: 0 0.5625rem;
}

.home-topbar h1 {
  margin: 0;
  color: #8f3fe2;
  font-size: 0.8125rem;
  font-weight: 700;
}

.home-topbar__signal {
  border: 0;
  background: transparent;
  display: flex;
  align-items: flex-end;
  width: 1.625rem;
  height: 1.6875rem;
  gap: 0.12rem;
  padding: 0;
}

.home-topbar__signal span {
  width: 0.18rem;
  border-radius: 0.25rem;
  background: linear-gradient(180deg, #d069bc 0%, #6f5bdb 100%);
}

.home-topbar__signal span:nth-child(1) { height: 0.8rem; }
.home-topbar__signal span:nth-child(2) { height: 1.1rem; }
.home-topbar__signal span:nth-child(3) { height: 1.35rem; }

.home-hero {
  position: relative;
  overflow: hidden;
  border-radius: 0.3rem;
  height: 8.75rem;
}

.home-hero__swipe,
.home-hero__swipe .van-swipe-item {
  height: 100%;
}

.home-hero__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.home-hero__image.is-single {
  animation: heroFloat 7s ease-in-out infinite alternate;
}

.home-hero__veil {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 18% 78%, rgba(251, 125, 208, 0.72) 0%, rgba(251, 125, 208, 0) 48%),
    linear-gradient(95deg, rgba(251, 109, 183, 0.45), rgba(147, 85, 163, 0.25));
}

.home-hero__chips {
  position: absolute;
  right: 0.7rem;
  top: 0.6rem;
  width: 13rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.3rem;
}

.home-hero__chips span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.4rem;
  font-size: 0.5625rem;
  color: #ffffff;
  border-radius: 999px;
  border: 0.06rem solid rgba(255, 165, 201, 0.95);
  background: linear-gradient(135deg, #d75b9d, #c74789);
  font-weight: 700;
}

.home-hero__note {
  position: absolute;
  left: 7.5rem;
  right: 0.6rem;
  bottom: 0.58rem;
  margin: 0;
  color: #ffe8ee;
  font-size: 0.5625rem;
  line-height: 1.25;
  border: 0.06rem solid rgba(255, 190, 214, 0.5);
  border-radius: 0.3rem;
  padding: 0.24rem 0.3rem;
  background: rgba(173, 73, 131, 0.54);
}

.home-notice {
  margin-top: 0.25rem;
  min-height: 1.1875rem;
  border-radius: 1rem;
  background: #ffffff;
  box-shadow: 0 0.03rem 0.4rem rgba(53, 27, 81, 0.1);
  display: flex;
  align-items: center;
  gap: 0.34rem;
  padding: 0 0.7rem;
  color: #9d78bf;
}

.home-notice p {
  margin: 0;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.6875rem;
}

.home-shortcuts {
  margin-top: 0.375rem;
  min-height: 3.25rem;
  border-radius: 0.45rem;
  background: #ffffff;
  box-shadow: 0 0.03rem 0.34rem rgba(27, 18, 58, 0.09);
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.home-shortcuts button {
  width: 3.32rem;
  height: 2.38rem;
  padding: 0;
  border: 0;
  border-radius: 0.45rem;
  background: #ede6f5;
}

.home-shortcuts button img {
  display: block;
  width: 1.75rem;
  height: 1.75rem;
  margin: auto;
  object-fit: contain;
  filter: brightness(0) saturate(1) invert(27%) sepia(26%) saturate(3735%) hue-rotate(252deg) brightness(86%) contrast(93%);
}

.home-list {
  margin-top: 0.375rem;
  margin-left: -0.0625rem;
  margin-right: -0.0625rem;
}

.home-list h2 {
  margin: 0 0 0.1875rem;
  font-size: 0.8125rem;
  line-height: 1;
  color: #252648;
  letter-spacing: 0.01em;
}

.guest-card {
  display: block;
  position: relative;
  padding-top: 0.375rem;
  padding-bottom: 0.5rem;
  text-decoration: none;
  color: #2a2640;
  margin-bottom: 0;
}

.guest-card__body {
  height: 12.0625rem;
  background: #ffffff;
  border-radius: 0.38rem;
  overflow: hidden;
  box-shadow: 0 0.04rem 0.45rem rgba(49, 31, 87, 0.12);
  display: grid;
  grid-template-columns: 46% 54%;
}

.guest-card__cover {
  position: relative;
  min-height: 12.0625rem;
  background: #efe8f6;
}

.guest-card__cover img {
  display: block;
  width: 100%;
  height: 11.1875rem;
  object-fit: cover;
}

.guest-card__ribbon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 0.5625rem;
  color: #be7d5a;
  background: #f6ddb8;
  font-style: normal;
  padding: 0.08rem 0.38rem;
  border-radius: 0 0 0 0.3rem;
}

.guest-card__meta {
  padding: 0.24rem 0.32rem 0.32rem;
}

.guest-card__badge-row {
  display: flex;
  gap: 0.16rem;
  margin-bottom: 0.14rem;
  flex-wrap: wrap;
}

.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 0.78rem;
  border-radius: 0.14rem;
  padding: 0 0.24rem;
  font-size: 0.5625rem;
  color: #ffffff;
  white-space: nowrap;
}

.badge--sand {
  color: #7f6548;
  background: #f8e6cd;
}

.badge--purple {
  background: #7c42ba;
}

.badge--orange {
  background: #ff8a00;
}

.badge--blue {
  background: #2f8de0;
}

.badge--amber {
  background: #f7a11d;
}

.guest-card__rating {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-top: 0.16rem;
  font-size: 0.6875rem;
  color: #3c3a52;
}

.guest-card__desc {
  margin: 0.14rem 0 0.2rem;
  font-size: 0.625rem;
  line-height: 1.25;
  color: #91889f;
}

.guest-card__cta {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.3rem;
  border-radius: 999px;
  color: #ffffff;
  font-size: 0.6875rem;
  font-weight: 700;
  background: linear-gradient(90deg, #8d47c8, #6a35b7);
}

.guest-card__name {
  display: block;
  height: 0.875rem;
  margin: 0.0625rem 0 0;
  text-align: center;
  font-size: 0.75rem;
  line-height: 0.875rem;
  color: #343450;
}

@keyframes heroFloat {
  0% {
    transform: scale(1.01) translateX(0);
  }
  100% {
    transform: scale(1.08) translateX(-1.8%);
  }
}

@media (min-width: 751px) {
  .home-shell {
    padding-left: 0.6rem;
    padding-right: 0.6rem;
  }

  .home-hero {
    height: 10.5rem;
  }
}
</style>
